import React from 'react'
import css from './Footer.module.css'
import logo from '../../assets/logo.png'
import {InboxIcon,PhoneIcon, LocationMarkerIcon, LoginIcon, UsersIcon, LinkIcon} from '@heroicons/react/outline';
const Footer = () => {
  return (
    <div className={css.cFooterWrapper}>
        <hr />
        <div className={css.cFooter}>
            <div className={css.clogo}>
                <img src={logo} alt="" />
                <span>amazon</span>
            </div>
            <div className={css.block}>
                <div className={css.detail}>
                    <span>Contact Us</span>
                    <span className={css.pngLine}>
                        <LocationMarkerIcon className={css.icon} />
                        <span>111 north avenue Orlando, FL 32801</span>
                    </span>
                    <span className={css.pngLine}>
                        <PhoneIcon className={css.icon}></PhoneIcon>
                        <a href="tel:111-222-333">111-222-333</a>
                    </span>
                    <span className={css.pngLine}>
                        <InboxIcon className={css.icon}></InboxIcon>
                        <a href="mailto:support@amazon.com">support@amazon.com</a>
                    </span>
                </div>
            </div>
            <div className={css.block}>
                <div className={css.detail}>
                    <span>Account</span>
                    <span className={css.pngLine}>
                        <LoginIcon className={css.icon} />
                        <span>Sign In</span>
                    </span>
                </div>
            </div>
            <div className={css.block}>
                <div className={css.detail}>
                    <span>Company</span>
                    <span className={css.pngLine}>
                        <UsersIcon className={css.icon} />
                        <span>Sign In</span>
                    </span>
                </div>
            </div>
            <div className={css.block}>
                <div className={css.detail}>
                    <span>Resources</span>
                    <span className={css.pngLine}>
                        <LinkIcon className={css.icon} />
                        <span>Safety Privacy & Terms</span>
                    </span>
                </div>
            </div>
        </div>
        <div className={css.copyright}>
            <span>Copyright 2022 by Zee.</span>
            <span>All rights reserved</span>
        </div>
    </div>
  )
}

export default Footer